// Actions
export const PROPERTY_MANAGER__GET_PROPERTIES = 'PROPERTY_MANAGER__GET_PROPERTIES';
export const PROPERTY_MANAGER__UPDATE_CURRENT_PROPERTY_ID =
  'PROPERTY_MANAGER__UPDATE_CURRENT_PROPERTY_ID';
export const PROPERTY_MANAGER__UPDATE_SEARCH_QUERY = 'PROPERTY_MANAGER__UPDATE_SEARCH_QUERY';
export const PROPERTY_MANAGER__UPDATE_SORT = 'PROPERTY_MANAGER__UPDATE_SORT';
// Getters
export const PROPERTY_MANAGER__PROPERTIES = 'PROPERTY_MANAGER__PROPERTIES';
export const PROPERTY_MANAGER__CURRENT_PROPERTY_ID = 'PROPERTY_MANAGER__CURRENT_PROPERTY_ID';
export const PROPERTY_MANAGER__SHOW_SINGLE_PROPERTY = 'PROPERTY_MANAGER__SHOW_SINGLE_PROPERTY';
// Mutations
export const PROPERTY_MANAGER__RESET = 'PROPERTY_MANAGER__RESET';
export const PROPERTY_MANAGER__MUTATE_CURRENT_PROPERTY_ID =
  'PROPERTY_MANAGER__MUTATE_CURRENT_PROPERTY_ID';
export const PROPERTY_MANAGER__MUTATE_PROPERTIES = 'PROPERTY_MANAGER__MUTATE_PROPERTIES';
export const PROPERTY_MANAGER__MUTATE_LOADING_STATUS = 'PROPERTY_MANAGER__MUTATE_LOADING_STATUS';
export const PROPERTY_MANAGER__MUTATE_SEARCH_QUERY = 'PROPERTY_MANAGER__MUTATE_SEARCH_QUERY';
export const PROPERTY_MANAGER__MUTATE_SORT = 'PROPERTY_MANAGER__MUTATE_SORT';
export const PROPERTY_MANAGER__MUTATE_FILTER = 'PROPERTY_MANAGER__MUTATE_FILTER';
